// IndexedDB initialization and database operations
const dbName = "SimSessionDB";
const dbVersion = 1;
let db;

// Initialize the database
export const initDB = (setIsIndexedDbInitialized) => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(dbName, dbVersion);

    request.onerror = (event) => {
      reject("Error opening database");
    };

    request.onsuccess = (event) => {
      db = event.target.result;
      resolve(db);
      console.debug("IndexedDB initialized successfully");
      setIsIndexedDbInitialized(true);
    };

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains("simulations")) {
        // id contains the comma separated value of simId, userId, and linkId
        const store = db.createObjectStore("simulations", { keyPath: "id" });
      }
    };
  });
};

export const addSimSession = (simSession) => {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(["simulations"], "readwrite");
    const store = transaction.objectStore("simulations");
    const request = store.put(simSession);

    console.debug("Request to add simulation => ", request);

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
};

export const getSimSessionById = (id) => {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(["simulations"], "readonly");
    const store = transaction.objectStore("simulations");
    const request = store.get(id);
    console.debug("Request to get simulation by ID => ", request);

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
};

export const deleteSimSessionById = (id) => {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(["simulations"], "readwrite");
    const store = transaction.objectStore("simulations");
    const request = store.delete(id);

    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
};
